export default function (state, data) {
    state.chart.data.labels = [];
    state.chart.data.datasets[0].data = [];
    state.chart.data.datasets[0].backgroundColor = [];
    data.AgreementsInStatuses.forEach(item => {
        state.chart.data.labels.push(item.StatusName);
        state.chart.data.datasets[0].data.push(item.Count);
        state.chart.data.datasets[0].backgroundColor.push(item.Color);
    });
    state.chart.AgreementsInStatuses = data.AgreementsInStatuses;
    state.chart.TotalCount = data.TotalCount;
}